import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Models } from '@ibexfusion/models';
import { ImageAssetsService } from '@services/assets/image-assets.service';
import { DialogService } from '@services/dialog/dialog.service';
import { TranslateService } from '@services/translate/translate.service';
import { EnvironmentService } from '@services/environment/environment.service';
import { SelectAssetsComponent } from '../../../../../../components/select-assets/select-assets.component';
import { VideoAssetsPropertiesService } from '@services/video-assets/video-assets-properties.service';

@Component({
    selector: 'slide-config',
    templateUrl: './slide-config.component.html',
    styleUrls: ['./slide-config.component.scss'],
    providers: [ImageAssetsService, VideoAssetsPropertiesService],
    standalone: false
})
export class SlideConfigComponent implements OnInit {

  public slideObject;

  public imageAssetPath: any;
  public videoPath: any;
  public timestamp = Date.now();

  public systemMessages;
  public isLoaded = false;
  private initialSlideObject: string;

  constructor(
    private dialog: MatDialog, private dialogService: DialogService, public dialogRef: MatDialogRef<SelectAssetsComponent>, private environmentService: EnvironmentService,
    @Inject(MAT_DIALOG_DATA) public data: any, private imageAssetsService: ImageAssetsService, private videoAssetsService: VideoAssetsPropertiesService, public ts: TranslateService
  ) {
    this.imageAssetPath = this.environmentService.getImageAssetPath();
    this.videoPath = this.environmentService.getVideoAssetPath();
  }

  async ngOnInit() {
    this.systemMessages = this.ts.get('system');
    this.slideObject = { slide: new Models.SlideItem(), file: null };
    this.slideObject.slide.type = this.data?.item?.type || 'image';
    this.slideObject.slide.duration = this.data?.item?.duration || 15;
    this.slideObject.slide.value = this.data?.item?.value || null;
    if (this.data?.item) {
      let asset = await this[(this.data.item.type === 'video' ? 'video' : 'image') + 'AssetsService'].find(0, 1, { path: this.data.item.value });
      if (asset?.data?.length) {
        const file: any = this.data.item.type === 'image' ? new Models.ImageAsset() : new Models.VideoAsset();
        file.name = asset.data[0].originalFileName;
        file.mimeType = asset.data[0].mimeType;
        file.url = asset.data[0].path;
        this.slideObject.file = file;
      }
    }
    setTimeout(() => {
      this.initialSlideObject = JSON.stringify(this.slideObject);
      this.isLoaded = true;
    }, 100);
  }

  public saveDisabled() {
    return !this.slideObject?.slide?.value || JSON.stringify(this.slideObject) === this.initialSlideObject;
  }

  public async chooseFromAssets(type) {
    let dialogRef = this.dialog.open(SelectAssetsComponent, {
      width: '75%', height: '75%', panelClass: 'select-assets-modal', data: { type, multiple: false, title: type === 'video' ? 'Videos' : 'Bilder', page: 'package-image'}
    });
    const asset: any = await dialogRef.afterClosed().toPromise();
    if (!asset?.length) {
      return;
    }
    delete this.slideObject.file;
    delete this.slideObject.slide.value;
    if (type === 'video') {
      delete this.slideObject.slide.duration;
    }
    setTimeout(() => {
      const file: any = type === 'image' ? new Models.ImageAsset() : new Models.VideoAsset();
      file.name = asset?.data?.[0]?.originalFileName || asset?.[0]?.originalFileName;
      file.mimeType = asset?.data?.[0]?.mimeType || asset?.[0].mimeType;
      file.url = asset?.data?.[0]?.path || asset?.[0].path;
      this.slideObject.file = file;
      this.slideObject.slide.value = asset?.data?.[0]?.path || asset?.[0].path;
      if (type === 'video') {
        this.slideObject.slide.duration = asset?.data?.[0]?.duration || asset?.[0]?.duration || 0;
        if (!this.slideObject.slide.duration) {
          this.setVideoDurationByDomElement(asset?.data?.[0]?._id || asset?.[0]?._id);
        }
      }
    }, 10);
  }

  async setVideoDurationByDomElement(assetId) {
    const video = document.getElementById('slide-video') as any;
    if (!video) {
      return setTimeout(() => { this.setVideoDurationByDomElement(assetId); }, 50);
    }
    this.slideObject.slide.duration = Math.ceil(video.duration);
    this.videoAssetsService.patch(assetId, { duration: Math.ceil(video.duration) });
    video.addEventListener('loadedmetadata', () => {
      this.slideObject.slide.duration = Math.ceil(video.duration);
      this.videoAssetsService.patch(assetId, { duration: Math.ceil(video.duration) });
    });
  }

  public async saveSlide() {
    let err = null;
    if (!this.slideObject.slide.value || !this.slideObject.slide.value.length) {
      this.slideObject.slide.type = this.slideObject.slide.type === 'website' ? 'Please add the path to your website!' : 'Please choose a file';
    }
    if (err) {
      this.dialogService.confirm('Could not save: ' + err)
    } else {
      this.dialogRef.close(this.slideObject);
    }
  }

  public cancel() {
    this.dialogRef.close();
  }
}
